import * as React from "react";
import { FC, useEffect } from "react";
import { Button, Form, Input, message } from "antd";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import "./login-page.less";
import { Link, useHistory } from "react-router-dom";
import { useForm } from "antd/lib/form/Form";
import { UserOutlined, LockOutlined } from "@ant-design/icons";
import { login, loginByCode } from "states/account/account.api";
import {
  login as loginAction,
  fetchProfile,
} from "states/account/account.slice";
import { CoreResource, t } from "shared/plugins/localization";
import { DefaultErrorMessage } from "shared/constants/define-localization";
import { ROUTE_PREFIX } from "shared/constants/routes";
import useCallBackUrl from "shared/hooks/use-callback-url";
import { LoginResponse } from "states/account/account.models";
import { RootState } from "app.store";
import moment from "moment";

const LoginPage = () => {
  document.title = "Đăng Nhập Trang Quản Trị";
  const dispatch = useDispatch();
  const history = useHistory();
  const [form] = useForm();
  const [loading, setLoading] = React.useState(false);
  const [passCodeQuery, passCodeValue] = useCallBackUrl("passCode");
  const token = useSelector(
    (state: RootState) => state.account.token,
    shallowEqual
  );

  const onLoginSubmit = async (values: any) => {
    try {
      if (loading) {
        return;
      }
      setLoading(true);
      let loginResponse = {} as LoginResponse;
      if (passCodeQuery) {
        loginResponse = await loginByCode(passCodeQuery);
      } else {
        loginResponse = await login(values);
      }
      await dispatch(loginAction(loginResponse));
      history.push(ROUTE_PREFIX);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      message.error(
        error?.response?.data?.error?.message ??
          "Lỗi hệ thống"
      );
    }
  };
  const onAutoLogin = async () => {
    try {
      if (loading) {
        return;
      }

      setLoading(true);
      let loginResponse = {} as LoginResponse;
      if (passCodeValue) {
        loginResponse = await loginByCode(
          passCodeValue.trim().replaceAll(" ", "+")
        );
      }
      dispatch(loginAction(loginResponse));
      history.push(ROUTE_PREFIX);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      message.error(
        error?.response?.data?.error?.message ??
          "Lỗi hệ thống"
      );
    }
  };

  const checkAutoLogin = async () => {
    if (
      token &&
      token.refreshToken &&
      moment(token.refreshTokenExpires).isAfter(moment())
    ) {
      await dispatch(fetchProfile());
      history.push(ROUTE_PREFIX);
      return;
    }
    if (passCodeQuery) {
      await onAutoLogin();
    }
  };

  useEffect(() => {
    checkAutoLogin();
  }, []);
  return (
    <div className="loginlayout">
      <div className="header-login">
        <div className="logo">
          <img src={process.env.PUBLIC_URL + "/images/logo.png"} alt="" />
        </div>
      </div>
      <div className="body-login">
        <Form form={form} name="login-form" onFinish={onLoginSubmit}>
          <h1>Đăng Nhập</h1>
          <Form.Item
            name="userName"
            rules={[{ required: true, message: "Vui lỏng điền tên đăng nhập" }]}
          >
            <Input
              size={"large"}
              prefix={<UserOutlined />}
              placeholder="Tên đăng nhập hoặc email"
            />
          </Form.Item>
          <Form.Item
            name="password"
            rules={[{ required: true, message: "Vui lòng điền mật khẩu" }]}
          >
            <Input.Password
              size={"large"}
              prefix={<LockOutlined />}
              placeholder="Mật khẩu"
            />
          </Form.Item>
          <Form.Item>
            <Button
              type="primary"
              htmlType="submit"
              block={true}
              size="large"
              className="mb-2"
              loading={loading}
            >
              Đăng Nhập
            </Button>
            <Link className="login-form-forgot" to="/admin/forgot-password">
              Quên mật khẩu
            </Link>
          </Form.Item>
        </Form>
      </div>
    </div>
  );
};

export default LoginPage;
